import React from 'react'
import {Redirect, Route} from 'react-router-dom'
import {Context} from '../Context'

const PublicRoute = ({ component: Component, ...rest }) => (
  <Context.Consumer>
  {
    ({globalState, actions}) => {
      if (globalState.isAuthenticating) {
        return null;
      } else {
        return(
          <Route
            {...rest}
            render={ props =>
              globalState.user
              ? <Redirect to={{pathname: "/home", state: { from: props.location }}}/>
              : <Component {...props} />
            }
          />
        )
      }
    }
  }
  </Context.Consumer>
)

export default PublicRoute



// WEBPACK FOOTER //
// ./src/components/PublicRoute.js